module.exports = "/assets/listing/pizzaweekBannerDesktop.jpg?CHkq1Xc";